import { useState } from "react";
import { ReactComponent as Trash } from "assets/images/icons/trash.svg";
import Table from "utils/Table/Table";
import ProviderFilters from "../../common/ProviderFilters";
import {
	providerFiltersDefaultValues,
	providerWebHooksTableData,
    providerWebHookHeadings,
} from "../../helpers/data";

const ProviderWebHooksTable = () => {
	const [formValues, setFormValues] = useState({
		...providerFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () =>
		setFormValues({ ...providerFiltersDefaultValues });

	const getWalletData = () => {
		return providerWebHooksTableData.map((data) => ({
			...data,
			action: <Trash className="pointer" />,
		}));
	};

	const handleRowClick = (_, rowValues) => {
		// history.push(`/providers/${rowValues.transactionID}/overview`);
	};
	return (
		<>
			<div className="position-relative">
				<ProviderFilters
					formValues={formValues}
					handleChange={handleChange}
					handleSubmit={handleSubmit}
					handleSelect={handleSelect}
				/>
				<Table
					data={getWalletData()}
					headings={providerWebHookHeadings}
					rowClick={handleRowClick}
				/>
			</div>
		</>
	);
};

export default ProviderWebHooksTable;
